<template>
  <div class="div_container">
    <div class="logo_style" style="display: flex; margin: 0 auto">
      <el-image
        :src="data.logo"
        style="width: 50px; height: 50px; margin-right: 10px"
      />
      <h2 style="margin: auto 0">{{ data.company }}</h2>
    </div>

    <div class="div_el_menu">
      <el-menu
        :default-active="$route.path"
        mode="horizontal"
        router
        class="menu_style"
      >
        <el-menu-item
          v-for="(item, index) in data.routerList"
          :key="index"
          :index="item.router"
          style="border-bottom-color: transparent; margin: 0 15px"
        >
          {{ item.title }}
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavigationBarComponent",
  data() {
    return {
      data: global,
    };
  },
};
</script>

<style scoped>
.div_container {
  margin: 0 auto;
  width: 1400px;
  display: flex;
  align-items: center;
}

.div_el_menu {
  padding: 0 50px;
  margin: 0;
}

.menu_style {
  background: transparent;
  padding: 0;
  margin: 0;
}

.el-menu--horizontal > .el-menu-item {
  color: #000000;
  font-weight: bold;
}

.el-menu-item.is-active,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #2a82e4 !important;
  font-weight: bolder !important;
}
</style>



// WEBPACK FOOTER //
// src/components/navigationBarComponent/navigationBarComponent.vue